import { render, staticRenderFns } from "./TerritoryZipContainer.vue?vue&type=template&id=37097556&scoped=true&"
import script from "./TerritoryZipContainer.vue?vue&type=script&lang=js&"
export * from "./TerritoryZipContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37097556",
  null
  
)

export default component.exports